import React, {useEffect, useState} from "react";
import DonutChart from "../../DonutChart/DonutChart";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import ProgressChart from "../ProgressChart/ProgressChart";
import {Col, Row, Spinner} from "react-bootstrap";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_ALERTS_BY_FLOW_TYPE} from "../../../GraphQL/ReportGenerator/queries";
import {
    HIGH_FLOW_LEAK, LOW_FLOW_LEAK, MODERATE_FLOW_LEAK
} from "../../../Constants/constants";
import {
    getLastMonthEndDate, getLastMonthStartDate, gqlDateFormat
} from "../Utils/utils";
import moment from "moment/moment";

export default function AlertsByFlowType(props) {
    const DONUT_CHART_SIZE = '75%';
    const [isLoading, setIsLoading] = useState(true);
    const [chartData, setChartData] = useState();
    const [previousStartDate, setPreviousStartDate] = useState(getLastMonthStartDate())
    const [startDate, setStartDate] = useState(getLastMonthStartDate());
    const [previousEndDate, setPreviousEndDate] = useState(getLastMonthEndDate());
    const [dateApplied, setDateApplied] = useState(false);
    const [endDate, setEndDate] = useState(getLastMonthEndDate());
    const [csvData, setCsvData] = useState([]);
    const [responseData, setResponseData] = useState([]);

    const queryAlertsByFlowTypeData = () => {
        apolloClientReports.query({
            query: QUERY_GET_ALERTS_BY_FLOW_TYPE, variables: {
                from: gqlDateFormat(startDate), to: gqlDateFormat(endDate)
            }
        }).then(res => {
            const response = res?.data?.leakAlertChart;
            if (!response) {
                console.error(`Data from AlertsByFlowType is empty`);
            } else {
                let tempArray = response?.severity?.map((obj) => Object.values(obj));
                setResponseData(response);
                tempArray.map((element) => element.splice(0, 1));
                setChartData(tempArray);
            }
        })
    }

    const buildCsvData = (responseData) => {
        if (chartData) {
            let csvData = [];
            let headers = [' ', 'From', 'To', 'Total alerts', 'High', 'Moderate', 'Low'];
            csvData.push(headers);

            let row = [];
            let leakCounts = responseData.map((severityElement) => severityElement.value);
            row.push('', moment(startDate).format('LL'), moment(endDate).format('LL'), leakCounts.reduce((a, b) => a + b, 0), leakCounts[2], leakCounts[1], leakCounts[0]);
            csvData.push(row);

            let secondRow = [];
            secondRow.push('', '', '', '100%', `${getPercentage(HIGH_FLOW_LEAK)}%`, `${getPercentage(MODERATE_FLOW_LEAK)}%`, `${getPercentage(LOW_FLOW_LEAK)}%`);
            csvData.push(secondRow);
            return csvData;
        }
    }

    const getValue = (key) => {
        return chartData?.map((a) => a[0] === key ? a[1] : null).filter((b) => b !== null)[0];
    }

    const getPercentage = (key) => {
        let total = chartData?.reduce((acc, item) => acc + item[1], 0);
        let value = getValue(key);
        if (value === 0) return 0;
        const final = value / total * 100;
        if (firstDigitAfterPoint(final) >= 5) {
            return Math.ceil(final);
        } else {
            return Math.floor(final);
        }
    }

    const firstDigitAfterPoint = (number) => {
        return Math.floor((number - Math.floor(number)) * 10);
    }

    useEffect(() => {
        if ((previousStartDate !== startDate) && (previousEndDate !== endDate)) {
            setIsLoading(true);
            queryAlertsByFlowTypeData();
            setPreviousStartDate(startDate)
            setPreviousEndDate(endDate)
        }
    }, [startDate, endDate]);

    useEffect(() => {
        setCsvData(buildCsvData(responseData?.severity));
        setIsLoading(false);
    }, [chartData]);


    return (<>
        {!chartData && <Spinner animation="border" variant="primary"/>}
        {chartData && <Row>
            <Col md={12}>
                <p className={'card-title-main bold-title'}>{props.title}</p>
            </Col>
            <Col md={12}>
                <DateRangePicker startDate={startDate} endDate={endDate}
                                 setStartDate={setStartDate} setEndDate={setEndDate}
                                 setDateApplied={setDateApplied}
                                 hasExportCsv csvData={csvData}
                                 title={'Number of leak alerts'}
                                 fontSize={15}/>
            </Col>
            {isLoading && <Spinner animation="border" variant="primary"/>}
            {!isLoading && <>
                <Col md={12} className={'mb-3'}>
                    <DonutChart height={223} data={chartData} size={DONUT_CHART_SIZE}/>
                </Col>
                <Col md={12} className={'progress-bar-inline'}>
                    <Row>
                        <Col md={12}>
                            <ProgressChart title={'High Flow'} value={getValue(HIGH_FLOW_LEAK)}
                                           precentage={getPercentage(HIGH_FLOW_LEAK)} variant={"darkred"}/>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md={12}>
                            <ProgressChart title={'Moderate Flow'} value={getValue(MODERATE_FLOW_LEAK)}
                                           precentage={getPercentage(MODERATE_FLOW_LEAK)} variant={"red"}/>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md={12}>
                            <ProgressChart title={'Low Flow'} value={getValue(LOW_FLOW_LEAK)}
                                           precentage={getPercentage(LOW_FLOW_LEAK)}
                                           variant={"orange"}/>
                        </Col>
                    </Row>
                </Col>
            </>}
        </Row>}
    </>)
}
